module.exports = __webpack_public_path__ + "6cabb32321160c3e2183ac8b3a9bdc75.pdf";